import { Check, Field, useSection } from "./shared";

export default function PaymentSettingsForm({ data, integrations, status, onSave }) {
  const [form, set] = useSection(data);
  const stripe = integrations?.stripe || {};
  const stripeMode = stripe.mode === "live" ? "live" : "test";

  return (
    <form className="settings-card" onSubmit={(e) => { e.preventDefault(); onSave(form); }}>
      <h2>Payments & Tax</h2>
      <div className="settings-status-row">
        <span>Stripe mode: {stripeMode}</span>
        <span>Publishable key: {stripe.publishable_key_configured ? "configured" : "not configured"}</span>
        <span>Secret key: {stripe.secret_key_configured ? "configured" : "not configured"}</span>
        <span>Webhook: {stripe.webhook_configured ? "configured" : "not configured"}</span>
      </div>
      <div className="settings-grid">
        <Check label="Payments enabled" checked={form.payments_enabled} onChange={(v) => set("payments_enabled", v)} />
        <Field label="Collection mode"><select value={form.payment_collection_mode || "manual_review"} onChange={(e) => set("payment_collection_mode", e.target.value)}><option value="full_payment">Full payment</option><option value="deposit">Deposit</option><option value="either">Customer choice</option><option value="manual_review">Manual review</option></select></Field>
        <Field label="Deposit %"><input type="number" step="0.01" value={form.default_deposit_percentage || ""} onChange={(e) => set("default_deposit_percentage", e.target.value)} /></Field>
        <Check label="Allow full payment" checked={form.allow_full_payment} onChange={(v) => set("allow_full_payment", v)} />
        <Check label="Allow deposit" checked={form.allow_deposit_payment} onChange={(v) => set("allow_deposit_payment", v)} />
        <Check label="Tax enabled" checked={form.tax_enabled} onChange={(v) => set("tax_enabled", v)} />
        <Field label="Tax rate %"><input type="number" step="0.001" value={form.default_tax_rate || ""} onChange={(e) => set("default_tax_rate", e.target.value)} /></Field>
        <Field label="Service fee"><input type="number" min="0" step="0.01" value={form.service_fee || ""} onChange={(e) => set("service_fee", e.target.value)} /></Field>
        <Field label="Refund summary"><textarea value={form.refund_policy_summary || ""} onChange={(e) => set("refund_policy_summary", e.target.value)} /></Field>
      </div>
      <footer><span>{status}</span><button className="btn">Save Payments</button></footer>
    </form>
  );
}
